import { render, staticRenderFns } from "./EditSignatureComponent.vue?vue&type=template&id=15dda2e6&"
import script from "./EditSignatureComponent.vue?vue&type=script&lang=js&"
export * from "./EditSignatureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports